import { createTypes, createAction } from 'lib/action'

// remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// load company list
const SIGNATURE_IMAGE_LOAD_COMPANY_LIST = createTypes(
  `signatureImageLoadCompanyList`,
  `load`
)

// load table log
const SIGNATURE_IMAGE_LOAD_TABLE_LOG = createTypes(
  `signatureImageLoadTableLog`,
  `load`
)

// get detail
const SIGNATURE_IMAGE_GET_DETAIL = createTypes(
  `signatureImageGetDetail`,
  `load`
)

// create signature image
const SIGNATURE_IMAGE_CREATE = createTypes(`signatureImageCreate`, `create`)

// update signature image
const SIGNATURE_IMAGE_UPDATE = createTypes(`signatureImageUpdate`, `update`)

// delete signature image
const SIGNATURE_IMAGE_DELETE = createTypes(`signatureImageDelete`, `delete`)


// load user
const SIGNATURE_IMAGE_LOAD_USER = createTypes(
  `signatureImageLoadUser`,
  `load`
)

// remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// load company list
const signatureImageLoadCompanyList = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_LOAD_COMPANY_LIST.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SIGNATURE_IMAGE_LOAD_COMPANY_LIST.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_LOAD_COMPANY_LIST.FAITLURE),
}

// load table log
const signatureImageLoadTableLog = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_LOAD_TABLE_LOG.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SIGNATURE_IMAGE_LOAD_TABLE_LOG.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_LOAD_TABLE_LOG.FAITLURE),
}

// get detail
const signatureImageGetDetail = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_GET_DETAIL.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(SIGNATURE_IMAGE_GET_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_GET_DETAIL.FAITLURE),
}

// create signature image
const signatureImageCreate = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_CREATE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(SIGNATURE_IMAGE_CREATE.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_CREATE.FAITLURE),
}

// update signature image
const signatureImageUpdate = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_UPDATE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(SIGNATURE_IMAGE_UPDATE.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_UPDATE.FAITLURE),
}

// delete signature image
const signatureImageDelete = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_DELETE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(SIGNATURE_IMAGE_DELETE.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_DELETE.FAITLURE),
}

// load user
const signatureImageLoadUser = {
  request: (data) =>
    createAction(SIGNATURE_IMAGE_LOAD_USER.REQUEST, {
      data,
    }),
  success: (lists) => createAction(SIGNATURE_IMAGE_LOAD_USER.SUCCESS, { lists }),
  failure: () => createAction(SIGNATURE_IMAGE_LOAD_USER.FAITLURE),
}

export {
  REMOVE_LISTS,
  removeLists,
  signatureImageLoadCompanyList,
  SIGNATURE_IMAGE_LOAD_COMPANY_LIST,
  signatureImageLoadTableLog,
  SIGNATURE_IMAGE_LOAD_TABLE_LOG,
  signatureImageGetDetail,
  SIGNATURE_IMAGE_GET_DETAIL,
  signatureImageCreate,
  SIGNATURE_IMAGE_CREATE,
  signatureImageUpdate,
  SIGNATURE_IMAGE_UPDATE,
  signatureImageDelete,
  SIGNATURE_IMAGE_DELETE,
  signatureImageLoadUser,
  SIGNATURE_IMAGE_LOAD_USER,
}
